import RefData from 'ref-data';
import { assetRefService } from '../common/Services';
import AppStoreConstants from './constants.js';

/**
 * splits the userAction into it's component parts and returns them as an array.
 * @param      {String}     userActionRef     the user action string
 * @return     {Array}                       the broken out elements required
 */
const getUserActionElements = (userActionRef) => {
  if (!userActionRef) return false;
  return userActionRef.split(/(?!:\/):/g);
};

/**
 * prep the slide data for the carousel on the app store home page
 * @param       {Array}       slides    the array of slides being added to the carousel
 */
const prepCarouselData = (slides) => {
  if (slides) {
    return slides.map((slide) => {
      return {
        ...slide,
        assetObj: assetRefService.fileFromAssetRef(slide.assetRef),
      };
    });
  }
};

/**
 * we can do a little prep work on our data here in case we need some of the attributes massages
 * @param      {array}     slides     list of carousel slides to pass through to the manipulation method
 * @return     {array}               list of carousel slides after the manipulation is complete
 */
const prepSlidesData = (slides) => slides.map((slide) => prepSlideData(slide));

/**
 * prep individual carousel slides
 * @param      {object}     slide     an individual slide record
 * @return     {object}              the slide record after we've updated the attributes
 */
const prepSlideData = (slide) => ({
  ...slide,
  image: assetRefService.pathFromAssetRef(slide.assetRef),
});

/**
 * work out the details for the CTA on the app detail page based on the app type and whether it's been added to the account already
 * @param      {Object}     app     the app object
 * @param      {Object}     added   this is an indication the user has clicked the button in the past for this app or in this window session for expansions
 * @return     {String}             the actionRef we've determined provides the next correct action for the app
 */
const determineCtaDetails = ({ id, friendlyId, appType, title, added }) => {
  switch (appType) {
    case RefData.Enum.TYPE.STOREAPP.EXPERIENCE:
      return added
        ? {
          ...AppStoreConstants.CTA_CONFIG_EXPERIENCE_ADDED,
          actionRef: `userAction:create:${id}`,
          tooltip:   'Create a new experience from this App',
        }
        : {
          ...AppStoreConstants.CTA_CONFIG_EXPERIENCE_NOT_ADDED,
          actionRef: `userAction:add:id=${friendlyId}`,
          tooltip:   `This will add the ${title} to your account`,
        };

    case RefData.Enum.TYPE.STOREAPP.SVCSPACKAGE:
      return added
        ? {
          ...AppStoreConstants.CTA_CONFIG_EXPANSION_REQUESTED,
          actionRef: `userAction:service:id=${friendlyId}`,
          tooltip:   null,
        }
        : {
          ...AppStoreConstants.CTA_CONFIG_EXPANSION_NOT_REQUESTED,
          actionRef: `userAction:service:id=${friendlyId}`,
          tooltip:
              'A request will be sent to your account\'s Customer Success Manager who will contact you with details',
        };
    default:
      return '';
  }
};

export { getUserActionElements, prepCarouselData, prepSlidesData, prepSlideData, determineCtaDetails };
